module.exports = __webpack_public_path__ + "media/images/result_sets/circles/6r5n9n3n-53eb7dfd109968257fdfd8802c17cdd7.svg";